<template>
    <tr class="requests__list_table_item">
        <td class="requests__list_table_item_name">{{ requestName }}</td>
        <td class="requests__list_table_item_coursename">{{ requestCourseName }}</td>
        <td class="requests__list_table_item_date">
            {{requestsDate}}<br>
            <component-text :size="'small'">Time: {{requestsTime}}</component-text>
        </td>
        <td class="requests__list_table_item_status">
            <component-status :status="requestsStatus"></component-status>
        </td>
        <td class="requests__list_table_item_actionedby">{{ requestActionedBy }}</td>
        <td class="requests__list_table_item_actions">
            <div class="columns is-block-mobile columns--margin-1-mobile is-vcentered">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :name="'requests-list-table-item-actions-approve'"
                        :theme="'primary'"
                        :animate-loading="true"
                        :animate-loading-event-name="'approve-request'"
                        :disabled="disabled"
                        @click="performApproveEnrolment"
                    >Approve</component-button>
                </div>
                <div class="column is-narrow">
                    <component-button
                        :name="'requests-list-table-item-actions-reject'"
                        :theme="'default'"
                        :animate-loading="true"
                        :animate-loading-event-name="'reject-request'"
                        :disabled="disabled"
                        @click="performRejectEnrolment"
                    >Reject</component-button>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import { fromUTCDateTimeToLocalISOCustom, toLocaleDateTime, toLocaleTime } from '@/functions'
import { User } from '@/User'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentText from '@/components/default/shared/ComponentText'

export default {
  components: { ComponentText, ComponentButton, ComponentStatus },
  name: 'requests-list-table-item',
  data () {
    return {
      user: new User()
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    requestId () {
      return this.item.id
    },
    requestName () {
      return this.item.learnerName || '-'
    },
    requestCourseName () {
      return this.item.courseName || '-'
    },
    requestsDate () {
      return toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.createdAt) || '')
    },
    requestsTime () {
      return toLocaleTime(fromUTCDateTimeToLocalISOCustom(this.item.createdAt) || '')
    },
    requestsStatus () {
      return this.item.state
    },
    requestActionedBy () {
      return this.item.createdByName || '-'
    }
  },
  methods: {
    performApproveEnrolment () {
      this.$store.dispatch('ebsRequestGetApprove', this.requestId).then(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Requests approve',
          message: 'Request has been successfully approved.',
          status: 'success'
        })
        this.$emit('emit', { message: 'emit-perform-get-items' })
      }).finally(() => {
        this.$eventBus.$emit('stop-approve-request')
      }).catch(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Requests approve',
          message: `Request hasn't been approved.`,
          status: 'error'
        })
      })
    },
    performRejectEnrolment () {
      this.$store.dispatch('ebsRequestGetReject', this.requestId).then(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Requests reject',
          message: 'Request has been successfully rejected.',
          status: 'success'
        })
        this.$emit('emit', { message: 'emit-perform-get-items' })
      }).finally(() => {
        this.$eventBus.$emit('stop-reject-request')
      }).catch(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Requests reject',
          message: `Request hasn't been rejected.`,
          status: 'error'
        })
      })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/requests/requestslisttableitem";
</style>
